import { create } from 'zustand'
import { RealtimeAppointmentStatus } from '../types'

type RealtimeAppointmentStore = {
  appointments: RealtimeAppointmentStatus[]
}

export const useRealtimeAppointmentStore = create<RealtimeAppointmentStore>(
  () => ({
    appointments: [],
  }),
)
